import React, { forwardRef } from 'react'
import { withTheme } from 'styled-components'

import IconLarge from './IconLarge'
import IconMedium from './IconMedium'
import IconSmall from './IconSmall'
import IconLarger from './IconLarger'

const sanitizeSvgProps = (inputProps) => {
  const out = {}

  for (const [key, value] of Object.entries(inputProps)) {
    if (value == null) continue

    // style (objet) est valide en React
    if (key === 'style') {
      out[key] = value
      continue
    }

    // handlers OK
    if (key.startsWith('on') && typeof value === 'function') {
      out[key] = value
      continue
    }

    // aria-* / data-* uniquement si primitive
    if (
      (key.startsWith('aria-') || key.startsWith('data-')) &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      out[key] = value
      continue
    }

    // primitives OK
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value
      continue
    }

    // sinon: objet / array / React element => on drop
  }

  return out
}



export const getIconSize = ({
    isSmallest,
    isSmaller,
    isSmall,
    isLarge,
    isLarger,
    isLargest,
    theme,
}) => {
    if (isSmallest) {
        return theme.iconSizeSmallest
    }
    if (isSmaller) {
        return theme.iconSizeSmaller
    }
    if (isSmall) {
        return theme.iconSizeSmall
    }
    if (isLarge) {
        return theme.iconSizeLarge
    }
    if (isLarger) {
        return theme.iconSizeLarger
    }
    if (isLargest) {
        return theme.iconSizeLargest
    }
    return theme.iconSize
}

const Icon = forwardRef(
    (
        {
            theme,
            isSmall,
            isSmallest,
            isSmaller,
            isLarge,
            isLarger,
            isLargest,
            ...props
        },
        ref,
    ) => {
        const safeProps = sanitizeSvgProps(props)
        const finalSize = getIconSize({
            isSmallest,
            isSmaller,
            isSmall,
            isLarge,
            isLarger,
            isLargest,
            theme,
        })
        const renderSmall = isSmaller || isSmallest
        const renderLarge = isLarge 
        const renderLarger = isLarger || isLargest
        if (renderSmall) {
            return <IconSmall size={finalSize} ref={ref} {...safeProps} />
        }
        if (renderLarge) {
            return <IconLarge size={finalSize} ref={ref} {...safeProps} />
        }
        if (renderLarger) {
            return <IconLarger size={finalSize} ref={ref} {...safeProps} />
        }
        return <IconMedium size={finalSize} ref={ref} {...safeProps} />
    },
)

export default withTheme(Icon)
